const roundUnitValue = value => {
    return Math.round(value * 100) / 100;
};

export default roundUnitValue;
